import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { Badge, BadgeSize, BadgeType } from '../../../shared/components/badge/badge';
import { createClassName, createStyleHelper } from '../../../shared/utils/class-names';
import { IUserProfilesEnumsVerificationStatus } from '../../../verification/queries/verify.graphql';

import styles from './section-title-status.module.scss';

const style = createStyleHelper(styles, 'section-title-status');

export interface ISectionTitleStatusProps {
    className?: string;
    title: string | JSX.Element;
    verificationStatus: IUserProfilesEnumsVerificationStatus;
}

function mapVerificationStatus(status: IUserProfilesEnumsVerificationStatus) {
    switch (status) {
        case IUserProfilesEnumsVerificationStatus.Failed:
        case IUserProfilesEnumsVerificationStatus.NotMatched:
        case IUserProfilesEnumsVerificationStatus.NotSet:
            return BadgeType.DANGER;
        case IUserProfilesEnumsVerificationStatus.Pending:
        case IUserProfilesEnumsVerificationStatus.VerifiedPartial:
            return BadgeType.DEFAULT;
        case IUserProfilesEnumsVerificationStatus.Verified:
            return BadgeType.SUCCESS;
    }
}

export const SectionTitleStatus: FunctionComponent<ISectionTitleStatusProps> = ({
    className,
    title,
    verificationStatus,
}) => {
    return (
        <div className={createClassName([className, style()])}>
            <div className={style('title')}>
                {title}
                <Badge size={BadgeSize.BODY} type={mapVerificationStatus(verificationStatus)}>
                    <FormattedMessage
                        id={`account.verification.status.${verificationStatus.toLocaleLowerCase()}`}
                        defaultMessage={verificationStatus}
                    />
                </Badge>
            </div>
        </div>
    );
};
